import React from "react";
import Home from "./pages/Home";
import CustomerList from "./pages/CustomerList";
import CustomerForm from "./pages/CustomerForm";
import CustomerDetail from "./pages/CustomerDetail";
import OrderList from "./pages/OrderList";
import OrderForm from "./pages/OrderForm";
import OrderDetail from "./pages/OrderDetail";
import StaffList from "./pages/StaffList";
import StaffForm from "./pages/StaffForm";
import StaffDetail from "./pages/StaffDetail";
import LogList from "./pages/LogList";
import Login from "./components/Login";

export interface Route {
  path: string;
  name: string;
  icon: string;
  component: React.ReactNode;
  layout: string;
  hidden?: boolean;
  requiredRole?: string; // 'admin' hoặc 'staff'
  resourceType?: string; // loại tài nguyên: 'customer', 'order', 'staff'
  mobileVisible?: boolean; // hiển thị trên mobile bottom navigation
}

const routes: Route[] = [
  // Auth routes
  {
    path: "/login",
    name: "Đăng nhập",
    icon: "fas fa-key",
    component: <Login />,
    layout: "/auth",
    hidden: true,
  },
  
  // Admin routes
  {
    path: "/dashboard",
    name: "Trang chủ",
    icon: "fas fa-home",
    component: <Home />,
    layout: "/admin",
    requiredRole: "admin",
  },
  {
    path: "/customers",
    name: "Khách hàng",
    icon: "fas fa-users",
    component: <CustomerList />,
    layout: "/admin",
    resourceType: "customer",
    mobileVisible: true,
  },
  {
    path: "/customers/add",
    name: "Thêm khách hàng",
    icon: "fas fa-user-plus",
    component: <CustomerForm />,
    layout: "/admin",
    hidden: true,
    resourceType: "customer",
  },
  {
    path: "/customers/:id",
    name: "Sửa khách hàng",
    icon: "fas fa-user-edit",
    component: <CustomerForm />,
    layout: "/admin",
    hidden: true,
    resourceType: "customer",
  },
  {
    path: "/customers/:id/orders",
    name: "Chi tiết khách hàng",
    icon: "fas fa-user-tag",
    component: <CustomerDetail />,
    layout: "/admin",
    hidden: true,
    resourceType: "customer",
  },
  // Dedicated customer detail page now not used for edit
  {
    path: "/orders",
    name: "Đơn hàng",
    icon: "fas fa-shopping-cart",
    component: <OrderList />,
    layout: "/admin",
    resourceType: "order",
    mobileVisible: true,
  },
  {
    path: "/orders/add",
    name: "Thêm đơn hàng",
    icon: "fas fa-cart-plus", 
    component: <OrderForm />,
    layout: "/admin",
    hidden: true,
    resourceType: "order",
  },
  {
    path: "/orders/edit/:id",
    name: "Sửa đơn hàng",
    icon: "fas fa-edit",
    component: <OrderForm />,
    layout: "/admin",
    hidden: true,
    resourceType: "order",
  },
  {
    path: "/orders/:id",
    name: "Chi tiết đơn hàng",
    icon: "fas fa-receipt",
    component: <OrderDetail />,
    layout: "/admin",
    hidden: true,
    resourceType: "order",
  },
  {
    path: "/staff",
    name: "Nhân viên",
    icon: "fas fa-user-tie",
    component: <StaffList />,
    layout: "/admin",
    requiredRole: "admin",
    resourceType: "staff",
  },
  {
    path: "/staff/add",
    name: "Thêm nhân viên",
    icon: "fas fa-user-plus",
    component: <StaffForm />,
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
    resourceType: "staff",
  },
  {
    path: "/staff/edit/:id",
    name: "Sửa nhân viên",
    icon: "fas fa-user-edit",
    component: <StaffForm />,
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
    resourceType: "staff",
  },
  {
    path: "/staff/:id",
    name: "Chi tiết nhân viên",
    icon: "fas fa-id-card",
    component: <StaffDetail />,
    layout: "/admin",
    hidden: true,
    requiredRole: "admin",
    resourceType: "staff",
  },
  {
    path: "/logs",
    name: "Hoạt động",
    icon: "fas fa-history",
    component: <LogList />,
    layout: "/admin",
    resourceType: "log",
  },
  
  // Staff routes - không có quyền truy cập Dashboard
  {
    path: "/orders",
    name: "Đơn hàng",
    icon: "fas fa-shopping-cart",
    component: <OrderList />,
    layout: "/staff",
    resourceType: "order",
    mobileVisible: true,
  },
  {
    path: "/orders/add",
    name: "Thêm đơn hàng",
    icon: "fas fa-cart-plus", 
    component: <OrderForm />,
    layout: "/staff",
    hidden: true,
    resourceType: "order",
  },
  {
    path: "/orders/edit/:id",
    name: "Sửa đơn hàng",
    icon: "fas fa-edit",
    component: <OrderForm />,
    layout: "/staff",
    hidden: true,
    resourceType: "order",
  },
  {
    path: "/orders/:id",
    name: "Chi tiết đơn hàng",
    icon: "fas fa-receipt",
    component: <OrderDetail />,
    layout: "/staff",
    hidden: true,
    resourceType: "order",
  },
  {
    path: "/customers",
    name: "Khách hàng",
    icon: "fas fa-users",
    component: <CustomerList />,
    layout: "/staff",
    resourceType: "customer",
  },
  {
    path: "/customers/add",
    name: "Thêm khách hàng",
    icon: "fas fa-user-plus",
    component: <CustomerForm />,
    layout: "/staff",
    hidden: true,
    resourceType: "customer",
  },
  {
    path: "/customers/:id",
    name: "Sửa khách hàng",
    icon: "fas fa-user-edit",
    component: <CustomerForm />,
    layout: "/staff",
    hidden: true,
    resourceType: "customer",
  },
  {
    path: "/customers/:id/orders",
    name: "Chi tiết khách hàng",
    icon: "fas fa-user-tag",
    component: <CustomerDetail />,
    layout: "/staff",
    hidden: true,
    resourceType: "customer",
  },
  {
    path: "/logs",
    name: "Hoạt động",
    icon: "fas fa-history",
    component: <LogList />,
    layout: "/staff",
    resourceType: "log",
  },
];

export default routes; 